import React, { useState, useEffect } from "react";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { FormGroup, Label } from "reactstrap";
function MultiSelectWithoutFormik({
    options,
    keyField,
    placeholder,
    label,
    onChange,
    handleInput,
    disabled,
    value,
    multiple = true,
    required = true
  }) {
    const [selectedValue, setSelectedValue] = useState(multiple ? [] : null);
    useEffect(() => {
      setSelectedValue(value);
    }, [value]);
    const handleSelectChange = (event, newValue) => {
      setSelectedValue(newValue);
      if (onChange) onChange(newValue);
    };
    return (
      <div className='input-field'>
        <FormGroup>
          <Label>{label}</Label>
          {required ? <span style={{ color: "red", marginLeft: "3px" }}>*</span> : <span>(Optional)</span>}
          <Autocomplete
            sx={{ m: 1, width: 500 }}
            multiple={multiple}
            options={options}
            getOptionLabel={(option) => option.label}
            value={selectedValue}
            onChange={handleSelectChange}
            onInputChange={handleInput}
            disabled={disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={placeholder}
                disabled={disabled}
              />
            )}
            renderOption={(props, option, { selected }) => (
              <MenuItem
                {...props}
                key={option.value}
                value={option.value}
                sx={{ justifyContent: "space-between" }}
              >
                {option.label}
                {selected ? <CheckIcon color="info" /> : null}
              </MenuItem>
            )}
          />
        </FormGroup>
      </div>
    );
  }

  export default MultiSelectWithoutFormik;
